(() => {
  const rootSelector = '[data-mercurias-quick-links]';
  const scrollerSelector = '[data-mercurias-quick-links-scroller]';
  const threshold = 1;

  const updateState = (root) => {
    const scroller = root.querySelector(scrollerSelector);

    if (!scroller) return;

    const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
    const isScrollable = maxScrollLeft > threshold;
    const isAtStart = scroller.scrollLeft <= threshold;
    const isAtEnd = scroller.scrollLeft >= maxScrollLeft - threshold;

    root.classList.toggle('is-scrollable', isScrollable);
    root.classList.toggle('is-at-start', isScrollable && isAtStart);
    root.classList.toggle('is-at-end', isScrollable && isAtEnd);
    root.classList.toggle('is-scrolled', isScrollable && !isAtStart);
  };

  const setupScroller = (root) => {
    const scroller = root.querySelector(scrollerSelector);

    if (!scroller || root.dataset.quickLinksScrollReady === 'true') return;

    root.dataset.quickLinksScrollReady = 'true';

    let frame = null;
    const requestUpdate = () => {
      if (frame) return;

      frame = window.requestAnimationFrame(() => {
        frame = null;
        updateState(root);
      });
    };

    scroller.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    updateState(root);

    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(requestUpdate);
      resizeObserver.observe(scroller);
      const list = scroller.querySelector('.mercurias-collection-quick-links__list');

      if (list) {
        resizeObserver.observe(list);
      }
    }
  };

  const initQuickLinks = (scope = document) => {
    scope.querySelectorAll(rootSelector).forEach(setupScroller);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initQuickLinks());
  } else {
    initQuickLinks();
  }

  document.addEventListener('shopify:section:load', (event) => initQuickLinks(event.target));
})();
